/**
 * @generated SignedSource<<9627ccf1dc5529fd43eacfd985fcef64>>
 * @relayHash d73e65fe5749ee9c2f73f4875fffe27e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90e72fc697e843da2922c35b65a13735a187ce5fc3df37b1c9dcf91160748561

import type { ConcreteRequest } from 'relay-runtime';
export type UsageViewAnalyticsActivationQuery$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type UsageViewAnalyticsActivationQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type UsageViewAnalyticsActivationQuery = {
  response: UsageViewAnalyticsActivationQuery$data;
  variables: UsageViewAnalyticsActivationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "condition": "isEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "cloudIds.0",
                "variableName": "cloudId"
              }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
          }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "product",
                "value": "atlassian-analytics-free"
              }
            ],
            "concreteType": "TenantContextActivationId",
            "kind": "LinkedField",
            "name": "activationIdByProduct",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "active"
              }
            ],
            "storageKey": "activationIdByProduct(product:\"atlassian-analytics-free\")"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UsageViewAnalyticsActivationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsageViewAnalyticsActivationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d73e65fe5749ee9c2f73f4875fffe27e",
    "id": "90e72fc697e843da2922c35b65a13735a187ce5fc3df37b1c9dcf91160748561",
    "metadata": {},
    "name": "UsageViewAnalyticsActivationQuery",
    "operationKind": "query",
    "text": "query UsageViewAnalyticsActivationQuery(\n  $cloudId: ID!\n  $isEnabled: Boolean!\n) {\n  tenantContexts(cloudIds: [$cloudId]) @include(if: $isEnabled) {\n    activationIdByProduct(product: \"atlassian-analytics-free\") {\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd1541f886dbce03e4bb79ff179366c5";

export default node;
